<template>
    <div>
        <el-date-picker v-model="selectDate" ref="datePicker" :type="type" :value-format="formatType" placeholder="选择日期" :picker-options="pickerOptions1" @change="changePick"></el-date-picker>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    export default {
        name: 'swb-shop-device-imp-set-date',
        desc: '设置日期',
        props: {
            formatType: {
                type: String,
                default: "yyyy-MM-dd"
            },
            defaultDate: {
                type: Date,
                default: null
            }
        },
        data: function () {
            return {
                selectDate: null,
                type: "date",
                pickerOptions1: {
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                }
            }
        },
        created: function () {
            if(this.formatType == 'yyyy-MM' || this.formatType == 'yyyyMM') {
                this.type = "month";
            }
            if(this.defaultDate != null){
                this.selectDate = this.defaultDate;
            }
        },
        methods: {
            changePick(value){
                this.selectDate = value;
            },
            getDlgResult(){
                // 提供回调函数，返回结果
                let result = {};
                if(this.selectDate != null) {
                    result.type = "info";
                    result.data = this.selectDate;
                } else {
                    result.type = "wran";
                    result.message = "请选择日期";
                }
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceImpSetDate.vue